module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/november-27fc38b977e09377b9ee83d6d345a27b.png";